module.exports = __webpack_public_path__ + "static/media/Crouch End Alcoves 3.07d3894f.jpg";